function CtaButton({
  variant,
  label,
  href,
  target,
  rel,
  icon,
  iconPosition = 'after',
  size = 'btn--lg',
  onClick,
}) {
  const finalRel = target === '_blank' ? (rel || 'noopener noreferrer') : rel;
  const iconEl = icon ? <i className={`ph ${icon}`} aria-hidden="true"></i> : null;
  return (
    <a
      href={href}
      target={target}
      rel={finalRel}
      onClick={onClick}
      className={`btn btn--${variant} ${size}`}
    >
      {iconPosition === 'before' && iconEl}
      {label}
      {iconPosition === 'after' && iconEl}
    </a>
  );
}

export default function DarkCta({
  eyebrow,
  title,
  description,
  primary,
  secondary,
  sectionClassName = '',
  withGridLines = true,
}) {
  const sectionClass = [
    'cta-block-section',
    withGridLines ? '' : '',
    sectionClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={sectionClass}>
      <div className="container">
        <div className="cta-block">
          <div className="cta-block__text">
            {eyebrow && <span className="cta-block__eyebrow">{eyebrow}</span>}
            {title && <h2 className="cta-block__title">{title}</h2>}
            {description && <p className="cta-block__sub">{description}</p>}
          </div>
          {(primary || secondary) && (
            <div className="cta-block__actions">
              {primary && <CtaButton variant="primary" {...primary} />}
              {secondary && <CtaButton variant="secondary" {...secondary} />}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
